import { Dashboard } from '@src/main/modules/common/dashboard/domain/Dashboard';
import Card from '@src/main/ui/components/common/Card/Card';
import DashboardCardShowMoreButtons from '@src/main/ui/components/common/Dashboard/DashboardCardShowMore/DashboardCardShowMoreButtons/DashboardCardShowMoreButtons';
import DashboardCardShowMoreContent from '@src/main/ui/components/common/Dashboard/DashboardCardShowMore/DashboardCardShowMoreContent/DashboardCardShowMoreContent';
import DashboardCardShowMoreHeader from '@src/main/ui/components/common/Dashboard/DashboardCardShowMore/DashboardCardShowMoreHeader/DashboardCardShowMoreHeader';
import { HighlighFields } from '@src/main/ui/components/common/Dashboard/common/fields/highlighter/HighlighFields';
import { getIconId } from '@src/main/ui/components/common/Icon/IconId';
import { useDashboardContext } from '@src/main/ui/providers/dashboard/DashboardContextProvider';
import { useUserContext } from '@src/main/ui/providers/user/UserContextProvider';
import { FC } from 'react';

interface Props {
  dashboard: Dashboard;
  highlighFields?: HighlighFields[];
  onClickFavorites: () => void;
}

const defaultProps = { highlighFields: undefined };

const DashboardCardShowMore: FC<Props> = ({ dashboard, highlighFields, onClickFavorites }) => {
  const { setSelectedDashboard } = useDashboardContext();
  const { user } = useUserContext();
  return (
    <Card width="90vw" maxWidth="850px" maxHeight="75vh">
      <DashboardCardShowMoreHeader
        title={dashboard.name}
        icon={getIconId(dashboard.area.name)}
        isCertified={dashboard.isCertified}
        onClickClose={() => setSelectedDashboard(undefined)}
        highlighFields={highlighFields}
      />
      <DashboardCardShowMoreContent
        areas={[dashboard.area.name, dashboard.area.subareaName, dashboard.area.subsubareaName]}
        keyTags={dashboard.keyTags}
        tags={dashboard.tags}
        refreshDate={dashboard.refreshDate}
        views={dashboard.views}
        description={dashboard.description}
        highlighFields={highlighFields}
      />
      <DashboardCardShowMoreButtons
        onClickFavorites={onClickFavorites}
        isFavorite={!!user?.favorites.includes(dashboard.id)}
        launchUrl={`/dashboard/${dashboard.id}`}
      />
    </Card>
  );
};

DashboardCardShowMore.defaultProps = defaultProps;

export default DashboardCardShowMore;
